import React, { useState } from 'react';

import NewModal from '../../components/new-modal-steps';
import { steps } from './constants';
import Item from './steps/item';
import { loadUserProfile, saveUserToLocal } from '../../utils/apiUtils';
import { checkEnableViewModulesByName } from '../../utils/commonFunctions';
// import IntroducingTheGlobalNetworkItem from '../../components/gsn/IntroducingTheGlobalNetworkItem';

const isOwner = (user) => {
  return user?.roles?.fleetId?.ownerId === user?._id;
};
const Welcome = ({ props }) => {
  const [open, setOpen] = useState(
    props.auth?.welcomeOpen || props.auth?.user?.showWelcome,
  );
  const params = new URLSearchParams(window.location.search);
  const step = params.get('step') || '';

  const handleClose = () => {
    setOpen(false);
    const userLocal = loadUserProfile();
    userLocal.user = userLocal.user || {};
    userLocal.user.showWelcome = false;
    saveUserToLocal({ ...userLocal, welcomeOpen: false });
  };

  const modulesHydra = checkEnableViewModulesByName(
    props.auth.selectedFleet,
    'Network Settings',
  );
  // const newSteps = modulesHydra
  //   ? steps.concat({
  //       key: 'step5',
  //       children: <IntroducingTheGlobalNetworkItem onClose={handleClose} from="welcome" step="4" />,
  //     })
  //   : steps;
  const newSteps = steps
  return (
    <>
      <NewModal
        defaultStep={step}
        customStyle={{ maxWidth: '450px' }}
        open={isOwner(props.auth?.user) && !props.auth?.user?.defaultPw && open}
        onClose={handleClose}
        onFinish={() => {
          handleClose();
          window.open('https://www.goodjourney.io/en/guide', '_blank');
        }}
        steps={newSteps.map((step) =>
          step.children ? step.children : <Item key={step.key} step={step} />,
        )}
      />
    </>
  );
};

export default Welcome;
